export default [
  {
    path: '/exception/404',
    name: 'Exception404',
    component: () => import('./Exception404.vue'),
    meta: {title: '404'}
  },
]
